<template>
  <section class="disclaimer">
    <div class="container">
      <div class="disclaimer__content01">
        <p>Without explicit consent, this information will not be directed to any specific individual, organization, or marketing activity outside the intended audience. This information is not an offer or commitment to any product or service and is subject to applicable laws and regulations in all jurisdictions, irrespective of nationality, residency, or registration. While we strive to ensure the accuracy, completeness, and integrity of the information, we do not accept liability for any inaccuracies or omissions.</p>
        <p>It is your responsibility to ensure that your investments comply with the laws and regulations of your jurisdiction, and you accept any associated risks or consequences.</p>
        <p>We reserve the right, at our sole discretion, to discontinue or refuse to provide our products or services.</p>
        <p>This website is intended solely for Professional Clients and Eligible Counterparties, as defined by the FCA.</p>
        <p>The content on this website is for informational purposes only and does not constitute financial, investment, or tax advice or a recommendation by DBG MARKETS (UK) LLP</p>
      </div>

      <div class="disclaimer__content02">
        <p>Risk Warning:</p>
        <p>Please note that forex trading and trading in other leveraged products involves a significant level of risk and is not suitable for alll investors.</p>
        <p>Trading in financial instruments may result in losses as well as profits and your losses can be greater than your initiall invested capital.</p>
        <p>Before undertaking any such transactions, you should ensure that you fully understand the risks involved andl seek independent advice if necessary.</p>
        <p>Please read and ensure you fully understand our Risk Disclosure.</p>
        <p>Anyone opening a trading account needs to adhere to the laws of their local country as such laws may differ from country to country.</p>
        <p>DBG MARKETS（UK） LLP is authorised and regulated by the Financial Conduct Authority under the license FRN 469459.</p>
      </div>
    </div>
    <div class="copyright flex flex__center">
      Copyright © 2024-2027. All Rights Reserved.
    </div>

    <div class="disclaimer__content03">
      <div class="wrap">
        <p>Please be advised that DBG Markets UK  LLP is not affiliated with the DBGM Group in any way.</p>
        <p>In addition, we are aware of numerous clone websites that may appear similar to ours. To ensure you are dealing with a legitimate, authorized firm, please refer to the FCA Register: DBG MARKETS (UK) LLP. Always verify the company’s details and authorization status before proceeding with any transactions.</p>
        <p>If you have any concerns or require further information, we encourage you to contact us directly.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'disclaimer',
}
</script>

<style scoped lang="scss">
.disclaimer {
  padding-top: 82px;
  padding-bottom: 150px;
  margin: 52px auto 0;
  p {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
  }
  .warning {
    margin-top: 32px;
    color: rgba(255, 255, 255, .6);
  }
  .copyright {
    height: 56px;
    margin-top: 48px;
    background: rgba(255, 255, 255, 0.08);
  }
  .container{
    width: 1120px;
  }
  .disclaimer__content01{
    margin-bottom: 32px;
  }
  .disclaimer__content02{
    opacity: 0.65;
  }
  .disclaimer__content03{
    padding: 24px 0;
    background: rgba(0, 0, 0, 0.9);
    width: 100%;
    margin: 0 auto;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    z-index: 200;
    .wrap{
      max-width: 1120px;
      margin: 0 auto;
    }
  }
}

@media screen and(max-width: 992px) {
  .disclaimer .container{
    width: 100vw;
    padding: 20px 15px 0 15px;

  }
  .copyright{
    height: 36px !important;
  }
  .disclaimer{
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
    p{
      line-height: 20px;
    }
    .disclaimer__content01{
      margin-bottom: 24px;
    }
    .disclaimer__content03{
      position: static;
      left: 0;
      transform: translateX(0);
      .wrap{
        max-width: 100%;
        padding: 0 15px;
      }
    }
  }
}
</style>
